// extracted by mini-css-extract-plugin
module.exports = {"price":"FormattedPrice_price___sBrT"};